// extracted by mini-css-extract-plugin
export default {"heading":"landing_heading__lqpxh"};